<template>
  <div
    class="block-white-normal mb-large cards-layout"
    :class="`cards-layout--${variant}`"
  >
    <slot name="default"></slot>
  </div>
</template>

<script>
export default {
  name: "BaseContainer",
  props: {
    variant: {
      type: String,
      default: "normal",
      validator(value) {
        return ["normal", "no-padding"].includes(value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes background-pulse {
  0% {
    background-size: 100%;
  }

  100% {
    background-size: 200%;
  }
}

.cards-layout {
  background: transparent;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    opacity: 0.5;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    animation: background-pulse 2s ease-in-out infinite;
    animation-fill-mode: revert;
    animation-direction: alternate-reverse;
    animation-play-state: paused;
    background: linear-gradient(
        270deg,
        var(--color-white) 0%,
        var(--color-white-blue) 100%
      )
      right;
  }

  &:hover {
    animation-play-state: running;
  }

  &--no-padding {
    padding: 0;
  }
}
</style>
